// tslint:disable
/**
 * Ux
 * insightux api
 *
 * The version of the OpenAPI document: 3.42
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { DatapointFilterFromJSON, DatapointFilterToJSON, DatapointsExcelRequestItemFromJSON, DatapointsExcelRequestItemToJSON, } from './';
export function DatapointsExcelRequestSpecificsFromJSON(json) {
    return {
        'requests': json['requests'].map(DatapointsExcelRequestItemFromJSON),
        'filters': !exists(json, 'filters') ? undefined : json['filters'].map(DatapointFilterFromJSON),
        'entityName': !exists(json, 'entityName') ? undefined : json['entityName'],
        'entitySubName': !exists(json, 'entitySubName') ? undefined : json['entitySubName'],
    };
}
export function DatapointsExcelRequestSpecificsToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    return {
        'requests': value.requests.map(DatapointsExcelRequestItemToJSON),
        'filters': value.filters === undefined ? undefined : value.filters.map(DatapointFilterToJSON),
        'entityName': value.entityName,
        'entitySubName': value.entitySubName,
    };
}
